/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./common-hot-picture.vue?vue&type=template&id=23b51545&scoped=true&"
import script from "./common-hot-picture.vue?vue&type=script&lang=ts&"
export * from "./common-hot-picture.vue?vue&type=script&lang=ts&"
import style0 from "./common-hot-picture.vue?vue&type=style&index=0&id=23b51545&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b51545",
  null
  
)

export default component.exports